var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"invoice-page"}},[(_vm.boleto.length == 0)?_c('div',{staticClass:"alert alert-danger text-center"},[_vm._v("\n    Nenhum boleto encontrado\n  ")]):_c('div',{class:`${_vm.insideApp == true ? 'bg-white p-2' : 'quebraPagina'}`},[_c('boleto',{attrs:{"dados":_vm.boleto[0].dadosToBoleto}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }